import React from 'react';
// SVG component, region separator
export default function SVGRegionSeparators(_ref) {
  var model = _ref.model,
    height = _ref.height;
  var dynamicBlocks = model.dynamicBlocks,
    offsetPx = model.offsetPx,
    interRegionPaddingWidth = model.interRegionPaddingWidth;
  return React.createElement(React.Fragment, null, dynamicBlocks.contentBlocks.slice(1).map(function (block) {
    return React.createElement("rect", {
      key: block.key,
      x: block.offsetPx - offsetPx - interRegionPaddingWidth,
      width: interRegionPaddingWidth,
      y: 0,
      height: height,
      fill: "grey"
    });
  }));
}